import { useMemo } from 'react';
import { UAParser } from 'ua-parser-js';

export function useUserAgent() {
  const uaParser = useMemo(() => {
    const parser = new UAParser(navigator.userAgent);
    const os = parser.getOS().name?.toLowerCase();

    return {
      isMac: os?.includes('mac') ?? false,
      isWindows: os?.includes('windows') ?? false,
      ...parser,
    };
  }, []);

  return uaParser;
}
